import t from "./ghl-ui.es1236.js";
import e from "./ghl-ui.es1237.js";
import o from "./ghl-ui.es1238.js";
var i = "[object Null]", f = "[object Undefined]", r = t ? t.toStringTag : void 0;
function m(n) {
  return n == null ? n === void 0 ? f : i : r && r in Object(n) ? e(n) : o(n);
}
export {
  m as default
};
